import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { DropdownItem } from 'reactstrap';
import { hasPrivilege } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';
import { selectedOne, singleSelected } from '../../../stores/tables/selectors';

interface Props extends RouteComponentProps, LocalizeContextProps {
    hasPrivilege: (privileges: string[]) => boolean;
    singleSelected?: string;
}

class CopyGroupAction extends React.Component<Props> {
    public constructor(props: Props) {
        super(props);
    }

    public render() {
        const t = this.props.translate;
        if (this.props.singleSelected &&
            this.props.hasPrivilege(['ADD_GROUP', 'USER_ADMIN', 'SUPER_ADMIN'])) {
            return (
                <React.Fragment>
                    <DropdownItem
                        onClick={() => {
                            this.props.history.push(`/groups/copy/${this.props.singleSelected}`);
                        }}
                    >
                        <FontAwesomeIcon icon={['fal', 'copy']} />
                        {t('groups.button.copy')}
                    </DropdownItem>

                </React.Fragment>
            );
        } else {
            return null;
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    hasPrivilege: hasPrivilege(state),
    singleSelected: singleSelected(state, 'groups'),
});

export default connect(mapStateToProps)(withRouter(withLocalize(CopyGroupAction)));